<template>
  <section id="app">
    <Header />
    <main>
      <router-view :key="$route.path"></router-view>
    </main>
    <Footer />
    <notifications group="results" />
  </section>
</template>

<style lang="scss">
@import "@/assets/scss/style";
</style>

<script>
import { mapActions } from "vuex";
import { logged, logout } from "@/services/user";
import { actionTypes } from "@/store/modules/User/action-types";
import Vue from "vue";
import Notifications from "vue-notification";
import axios from "axios";

import VueMeta from "vue-meta";
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

Vue.use(Notifications);
Vue.notify({
  duration: 10000,
  speed: 500,
});

export default {
  name: "App",
  metaInfo: {
    title: 'Prepress24.pl',
    meta: [
      {
        name: "robots",
        content: "index, nofollow",
      },
      { charset: 'utf-8' },
      {
        property: 'og:title',
        content: 'Prepress24.pl',
      },
      {
        property: 'og:description',
        content: 'Najwyższej jakości fotochemiczne metody wykonywania offsetowych form drukowych'
      },
      {
        property: 'description',
        content: 'Najwyższej jakości fotochemiczne metody wykonywania offsetowych form drukowych'
      },
      {
        property: 'keywords',
        content: 'Prepress24, Prepress, offsetowe formy drukowe'
      },
      {
        property: 'og:image',
        content: 'https://nowy.prepress24.pl/static/seo.jpg',
      },
      {
        property: 'twitter:image',
        content: 'https://nowy.prepress24.pl/static/seo.jpg',
      },
    ],
    htmlAttrs: {
      lang: "pl",
    },
  },
  components: {
    Header: () => import("@/pages/components/includes/Header"),
    Footer: () => import("@/pages/components/includes/Footer"),
  },
  created() {
    if (logged()) {
      this.ADD_USER_DATA().catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            this.logoutAction();
          }
        }
      });
    }

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.data.code === 401) {
          console.log("error token auth");
          console.log("Not authenticated - 401");
          this.logoutAction();
        }
      }
    );
  },
  methods: {
    ...mapActions("UserModule", [actionTypes.ADD_USER_DATA]),
    logoutAction() {
      logout();
      this.$router.push({ name: "Login" });
    },
  },
};
</script>
